<template>
    <div class="inlineblock-meaningless-wrapper">
        <ElasticButton
            :asyncClick="() => changeOpened()"
            :title="$t('patent-view.Report-data-error')"
            :disabled="false"
            :alwaysNeedTooltip="true"
            placement="left"
        >
            <PtIcon slot="icon" icon="SolidWarning" />
            <template #text>
                {{ $t('patent-view.Report-data-error') }}
            </template>
        </ElasticButton>
        <component
            :is="comp"
            v-if="comp && opened"
            @close="changeOpened"
        />
    </div>
</template>

<script>
import ElasticButton from '../../views/function-bar/ElasticButton';
import { Icon } from 'patsnap-biz';
import { getRouteNameList } from '../../router';
import '@patsnap-ui/icon/assets/solid/warning.svg';

export default {
    name: 'DataReport',
    components: {
        PtIcon: Icon,
        ElasticButton,
    },
    data() {
        return {
            comp: undefined,
            opened: false,
        };
    },
    methods: {
        async changeOpened() {
            this.comp || await this.loadComponent();
            window.rvTrack('Click Report Error', {
                source: getRouteNameList(this.$route),
                type: this.opened === false ? 'close-to-open' : 'open-to-close',
            });
            this.opened = !this.opened;
        },
        async loadComponent() {
            this.comp = await import('./DataReportDialog')
                .then(m => (m.default ? m.default : m));
        },
    },
};
</script>
